module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "color": "blue darken-3",
      "dark": "",
      "app": "",
      "clipped-left": _vm.$vuetify.breakpoint.mdAndUp,
      "fixed": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0 pl-3",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.dispatch('toggleMainMenuDrawer')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "to": "/logout"
    }
  }, [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "round": ""
    }
  }, [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Profile'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b3a724e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppToolbar.vue
// module id = 975
// module chunks = 1